(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["plantalea-card-gallery"] && !Shopify.designMode) return;
  try {
    function initPlantaleaGallery(root){
  if(root.dataset.galleryReady)return;
  root.dataset.galleryReady='true';
  const grid=root.querySelector('.pl-range-grid');
  const tiles=[...grid.querySelectorAll('.pl-range-card')];
  const dialog=root.querySelector('dialog');
  const large=dialog.querySelector('[data-card-large]');
  let current=[],index=0;
  function show(){const button=current[index];large.src=button.dataset.full;large.alt=button.getAttribute('aria-label');dialog.querySelector('[data-card-caption]').textContent=[...button.closest('article').querySelectorAll('.pl-range-caption span')].map(s=>s.textContent.trim()).join(' · ');}
  root.addEventListener('click',event=>{
    const filter=event.target.closest('[data-card-filter]');
    if(filter){root.querySelectorAll('[data-card-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===filter)));tiles.forEach(t=>t.hidden=filter.dataset.cardFilter!=='all'&&t.dataset.rarity!==filter.dataset.cardFilter);root.querySelector('[data-card-count]').textContent=tiles.filter(t=>!t.hidden).length;}
    const button=event.target.closest('[data-card-open]');
    if(button){const container=button.closest('.pl-range-grid,.pl-range-featured');current=[...container.querySelectorAll('[data-card-open]')].filter(b=>!b.closest('article').hidden);index=current.indexOf(button);show();dialog.showModal();}
    if(event.target.closest('[data-card-close]'))dialog.close();
    if(event.target.closest('[data-card-next]')){index=(index+1)%current.length;show();}
    if(event.target.closest('[data-card-previous]')){index=(index-1+current.length)%current.length;show();}
  });
  dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
  dialog.addEventListener('keydown',event=>{if(event.key==='ArrowRight'){event.preventDefault();index=(index+1)%current.length;show();}if(event.key==='ArrowLeft'){event.preventDefault();index=(index-1+current.length)%current.length;show();}});
}
document.querySelectorAll('[data-card-gallery]').forEach(initPlantaleaGallery);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-card-gallery]').forEach(initPlantaleaGallery));
  } catch(e) { console.error(e); }
})();

})();
